import { ESRI } from '@rsos/constants/mapProviders';

/**
 * Removes a marker instance based on the map provider
 * @param {Object} mapObject - map object
 * @param {Instance} marker - instance of the marker
 */
const removeMarker = (mapObject, marker, layer) => {
  switch (mapObject.mapProvider) {
    case ESRI: {
      layer.remove(marker.instance);
      break;
    }
  }
};

export default removeMarker;
